import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取活动列表
export const getActiveFreeParkingList = params => {
    return get("/admin/doingsInfo/page", params);
};
// 新增
export const addActiveFreeParking = params => {
    return post("/admin/doingsInfo/add2", params);
};
// 修改
export const editActiveFreeParking = params => {
    return post("/admin/doingsInfo/edit2", params);
};
// 修改活动状态
export const changeActiveStatus = params => {
	return put(`/admin/doingsInfo/turnStatus/${params}`,params);
	
};



// WEBPACK FOOTER //
// ./src/api/freeParking.js